export const SEARCH_WIDGET_TOOLTIP_DARK_STYLE_OVERRIDE = {
    background: 'secondary.default',
    color: 'white',
    borderRadius: 'md',
    button: {
        background: 'secondary.default',
        color: 'white',
        _hover: {
            color: 'white',
            background: 'secondary.default',
        },
    },
    div: {
        borderBottomColor: 'secondary.default',
    },
};
